import React from "react";

const Loader_9 = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="spinner-border" role="status"
        style={{fontSize: '7px', width: '100px', height: '100px'}}>
      </div>
    </div>
  );
};

export default Loader_9;